const byteScaleStep: number = 1024;

export const megabytesToBytes = (megabytes: number) => {
  return byteScaleStep * byteScaleStep * megabytes;
};

export const kilobytesToBytes = (kilobytes: number) => {
  return byteScaleStep * kilobytes;
};

export const bytesToMegabytes = (bytes: number) => {
  return bytes / (byteScaleStep * byteScaleStep);
};

export const bytesToKilobytes = (bytes: number) => {
  return bytes / byteScaleStep;
};

export const formatFileSize = (bytes: number): string => {
  const kb = bytesToKilobytes(bytes);
  if (kb < byteScaleStep) {
    return Number.isInteger(kb) ? `${kb} KB` : `${kb.toFixed(1)} KB`;
  }
  const mb = bytesToMegabytes(bytes);
  return Number.isInteger(mb) ? `${mb} MB` : `${mb.toFixed(1)} MB`;
};
